import React from 'react';
import { Link } from 'react-router-dom';
import { SERVICES, servicePath } from '../../data/services.mjs';
import { SITE } from '../../seo/site.mjs';
import CertifiedBadge from '../../components/credibility/CertifiedBadge';
import './footer.css';

const Footer = () => {
    return (
        <footer className="fables-footer-image fables-after-overlay white-color py-4 py-lg-5 bg-rules">
            <div className="container position-relative z-index">
                <div className="row">
                    <div className="col-12 col-lg-3 mb-4 mb-lg-0">
                        <a href="/"
                           className="pb-3 d-block mb-3"><img className="logo-white"
                            src="/assets/custom/images/logo-coralan-white.png" alt="Coralan Multiservice" width="480" height="147" loading="lazy" /></a>
                        <p className="font-15 fables-third-text-color mb-4">
                            Somos una empresa de soluciones digitales especializada en ayudar a las empresas
                            a tener presencia en internet, nuestro objetivo principal consiste en que su empresa sea
                            vista en todo internet y así ayudarle a aumentar las ventas y credibilidad de sus clientes.
                        </p>
                        <p className="mb-3">RNC: {SITE.rnc}</p>
                        <CertifiedBadge variant="dark" size="sm" />
                    </div>

                    <div className="col-12 col-sm-6 col-lg-3 mb-4 mb-lg-0">
                        <h2 className="font-20 semi-font fables-second-border-color border-bottom pb-3">Contáctenos</h2>
                        <div className="my-3">
                            <h4 className="font-16 semi-font"><span
                                className="fables-iconmap-icon fables-second-text-color pr-2 font-20 mt-1 d-inline-block"></span> Dirección</h4>
                            <p className="font-14 fables-fifth-text-color mt-2 ml-4">{SITE.addressDisplay}</p>
                        </div>
                        <div className="my-3">
                            <h4 className="font-16 semi-font"><span
                                className="fables-iconphone fables-second-text-color pr-2 font-20 mt-1 d-inline-block"></span> Whatsapp/Teléfono </h4>
                            <p className="font-14 fables-fifth-text-color mt-2 ml-4"><a href="tel:+18096050699" className="fables-fifth-text-color">{SITE.phoneDisplay}</a></p>
                        </div>
                        <div className="my-3">
                            <h4 className="font-16 semi-font"><span
                                className="fables-iconemail fables-second-text-color pr-2 font-20 mt-1 d-inline-block"></span> Correo
                            </h4>
                            <p className="font-14 fables-fifth-text-color mt-2 ml-4"><a href={`mailto:${SITE.email}`} className="fables-fifth-text-color">{SITE.email}</a></p>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-lg-3 mb-4 mb-lg-0">
                        <h2 className="font-20 semi-font fables-second-border-color border-bottom pb-3 mb-3">Servicios</h2>
                        <ul className="nav fables-footer-links">
                            {SERVICES.map((s) => (
                                <li key={s.slug}><Link to={servicePath(s.slug)}>{s.shortName}</Link></li>
                            ))}
                            <li><Link to="/facturacion-electronica">ERP con facturación electrónica</Link></li>
                            <li><Link to="/productos">Productos</Link></li>
                            <li><Link to="/servicios">Todos los servicios</Link></li>
                        </ul>
                        <h2 className="font-20 semi-font fables-second-border-color border-bottom pb-3 mb-3 mt-4">Conocer más</h2>
                        <ul className="nav fables-footer-links">
                            <li><a href="/#whychooseus">¿Por qué elegirnos?</a></li>
                            <li><a href="/#aboutus">Acerca de nosotros</a></li>
                            <li><a href="/#latestwork">Trabajos recientes</a></li>
                            <li><a href="/#ourplans">Precios</a></li>
                            <li><a href="/#contactenos">Contáctenos</a></li>
                        </ul>
                    </div>

                    <div className="col-12 col-sm-6 col-lg-3">
                        <h2 className="font-20 semi-font fables-second-border-color border-bottom pb-3 mb-3">Información Legal</h2>
                        <ul className="nav fables-footer-links">
                            <li><Link to="/politica-privacidad">Política de Privacidad</Link></li>
                            <li><Link to="/politica-cookies">Política de Cookies</Link></li>
                            <li><Link to="/terminos-de-uso">Términos de Uso</Link></li>
                            <li><Link to="/politica-de-contingencia">Política de Contingencia</Link></li>
                            <li><Link to="/soporte">Soporte</Link></li>
                        </ul>
                    </div>

                </div>

            </div>
        </footer>
    );
};

export default Footer;
